import { Drawer } from "@circleco/compass/components/Drawer";

import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

interface ProfileHeaderButtonProps {
  avatarUrl?: string;
  email?: string;
  name: string;
  onClick: () => void;
}

/**
 * Nav drawer's profile header row - tapping it opens the member's own
 * profile drawer.
 */
export const ProfileHeaderButton = ({
  name,
  avatarUrl,
  email,
  onClick,
}: ProfileHeaderButtonProps) => (
  <Drawer.Close>
    <button type="button" className="block w-full text-left" onClick={onClick}>
      <Drawer.Header
        prefix={
          <UserImage name={name} src={avatarUrl} size="10" isFullRounded />
        }
        title={name}
        subtitle={email || undefined}
        sticky
      />
    </button>
  </Drawer.Close>
);
